import {SActionBtn, SFuncModal, SLowcodeList, SMessage, STableActions} from "shj-components";
import {message, Switch, Form, Input, InputNumber} from "antd";

import {config} from "./config.tsx";
import {useNavigate} from "react-router-dom";
import {
  getPackModelPage, packModelCopy,
  packModelDelete,
  packModelUpdateById
} from "@/services/product.ts";
import {apiData2Table} from "@/utils/data.ts";
import {useRef} from "react";
import { KeepAlive } from 'react-activation';

const PackageTemplateList = () => {
  const navigate = useNavigate()
  const listRef = useRef();
  const [form] = Form.useForm()

  const fetchList = ({current, pageSize, query}) => {
    return new Promise((resolve, reject) => {
      getPackModelPage({params: {pageId: current, pageSize}, data: query}).then(res => {
        resolve(apiData2Table(res))
      }).catch(reject)
    })
  }

  const onChangeStatus = (enabled: boolean, record) => {
    SMessage.confirm({
      title: `${enabled ? '打开' : '关闭'}开关, 将${enabled ? '启用' : '禁用'}模板，是否继续？`,
      content: null,
      okText: '继续',
      onOk: () => {
        return packModelUpdateById({...record, enabled}).then((res: any) => {
          message.success(res.message || '操作成功');
          listRef.current?.reload()
        })
      },
    });
  }

  const onAdd = () => {
    localStorage.removeItem('packHistoryPath')
    navigate('/config/baseProduct/packageTemplate/addOrEdit')
  }

  const onEdit = (id: string) => {
    localStorage.removeItem('packHistoryPath')
    navigate(`/config/baseProduct/packageTemplate/addOrEdit/${id}`)
  }

  const onCopy = (record) => {
    form.setFieldsValue({name: record.modelName})
    const dialog = SFuncModal({
      title: '复制',
      content: <Form form={form} layout="vertical">
        <Form.Item label={'新对象名称'} name='name' required={true}
                   rules={[{required: true, message: '名称不能为空'}]}>
          <Input placeholder={`请输入新对象名称`} maxLength={30} showCount/>
        </Form.Item>
      </Form>,
      onOk: () => {
        form.validateFields().then((values: Record<string, string>) => {
          packModelCopy({packId: record.id, packName: values.name}).then(res => {
            message.success(res.message || '操作成功');
            listRef.current?.reload()
            dialog.destroy()
          })
        })
      }
    })
  }

  const handleSetSpaceSpecs = (id) => {
    navigate(`/config/baseProduct/packageTemplate/setSpaceSpecs/${id}`)
  }

  const onDel = (id: string) => {
    SMessage.confirm({
      onOk: () => {
        return packModelDelete(id).then((res: any) => {
          message.success(res.message || '操作成功');
          listRef.current?.reload()
        })
      },
    });
  }

  const extensions = {
    request: {fetchList},
    events: {onAdd},
    customRender: {
      switchRender(v: boolean | undefined, record: Record<string, any>) {
        return <Switch checkedChildren="启用" unCheckedChildren="禁用"
                       checked={!!v} onClick={(checked) => onChangeStatus(checked, record)}/>
      },
      actionRender(_: null, record: Record<string, any>) {
        return <STableActions>
          <SActionBtn onClick={() => onEdit(record.id)}>编辑</SActionBtn>
          <SActionBtn onClick={() => onCopy(record)}>复制</SActionBtn>
          <SActionBtn onClick={() => handleSetSpaceSpecs(record.id)}>空间规格配置</SActionBtn>
          {!record.enabled && <SActionBtn danger onClick={() => onDel(record.id)}>删除</SActionBtn>}
        </STableActions>
      },
      numberRender({name, form}) {
        return <InputNumber style={{width: '100%'}} placeholder={'请输入模板ID'}
                            onInput={(v) => {
                              form.setFieldsValue({[name]: v})
                            }}/>
      }
    }
  }
  return (
    <KeepAlive name={location.pathname}>
      <div>
        <SLowcodeList
            ref={listRef}
            searchMode={'group'}
            config={config}
            {...extensions}
        />
      </div>
    </KeepAlive>
  );
};

export default PackageTemplateList;
